module.exports = __webpack_public_path__ + "static/media/success-capture-5.6a462914.png";